module.exports = __webpack_public_path__ + "assets/apache-http-server.b554392c.svg";